








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ErrorBox extends Vue {
  @Prop({ default: "An error occurred." }) readonly message!: string;
}
